import { MARKETS } from './registry.js';
/**
 * The display label for a single market option `value`. For TEAM-RELATIVE markets
 * (`outcome`, `htResult`, `mostCards`) the HOME/AWAY options resolve to the actual
 * team names — the app must NEVER show a bare "Home"/"Away" — falling back to the
 * generic option label only when no team names are supplied. Every other market
 * returns its plain option label. Unknown ids/values pass through.
 */
export function selectionLabel(marketId, value, teams) {
    const m = MARKETS[marketId];
    if (m?.teamRelative && teams) {
        if (value === 'HOME')
            return teams.home;
        if (value === 'AWAY')
            return teams.away;
    }
    return m?.options?.find((o) => o.value === value)?.label ?? value;
}
//# sourceMappingURL=labels.js.map